import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import React from 'react';

// include local dependencies 
import "./power-bi-report.scss";

const PowerBiEmbed = ({ embedUrl, reportId, accessToken, reportPageName }:any) => {

  return (
    <>
      <PowerBIEmbed
        embedConfig={{
          type: 'report', // Supported types: report, dashboard, tile, visual and qna
          id: reportId,
          embedUrl: embedUrl,
          accessToken,
          pageName: reportPageName,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: {
                expanded: false,
                visible: false,
              },
            },
            // layoutType: models.LayoutType.MobilePortrait,
            background: models.BackgroundType.Transparent,
            filterPaneEnabled: false,
            navContentPaneEnabled: false,
          },
        }}
        eventHandlers={
          new Map([
            [
              'loaded',
              function () {
                console.log('Report loaded');
              },
            ],
            [
              'rendered',
              function () {
                console.log('Report rendered');
              },
            ],
            [
              'error',
              function (event) {
                console.log((event as any).detail);
              },
            ],
          ])
        }
        cssClassName={'report-style-class'}
        getEmbeddedComponent={(embeddedReport) => {
          (window as any).report = embeddedReport;
        }}
      />
    </>
  );
};

export default PowerBiEmbed;
